import React from "react"
import DeleteFilter from "../../../assets/iconos/close.svg";
import { latest as API_URL } from "../../../config/api";
import Helpers, { isActiveSlide, positionLeft } from "../../../config/Helpers";
import axios from "axios";

//Modulos
import General from "./views/General";
import Availability from "./views/Availability";

const postUrlLogin = API_URL + "widgets";

class Layout extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            response_request : [],
            request_status   : "hide",
            active_slide: { key: "general", index: 0 }, 
            touch_values : {
                start : 0,
                end: 0
            },
            slides : {
                0 : {
                    key: "general", index: 0
                },
                1: {
                    key: "availability", index: 1
                }
            },
            min_slide : 1,
            max_slide : 2,
            tab_submodule : 'inactive',
            tab_filters : 'inactive'    
        }
        this.setDefaultValuesModule = this.setDefaultValuesModule.bind(this);
        this._setStart              = this._setStart.bind(this)
    }
    setDefaultValuesModule(){
        let $self = this;
        this.setState({
            response_request : [],
        }, $self.props.app.mainRequest())
        
        this._Availability.setDefaultValuesModule();
    }
    activeSlide(slide){
        this.setState(function(prev){
            if(prev.activeSlide !== slide.key){
                return {
                    active_slide : slide
                }
            }
        })
    }
    activeSubmoduleTab() {
        this.setState(function(){
            const state = (this.state.tab_submodule === 'active') ? 'inactive' : 'active';
            return { 
                tab_submodule : state,
                tab_filters : 'inactive'
             }
        })
    }
    activeFiltersTab() {
        this.setState(function(){
            const state = (this.state.tab_filters === 'active') ? 'inactive' : 'active';
            return { 
                tab_submodule : 'inactive',
                tab_filters : state
             }
        })
    }
    _setStart(start_touch){
        let $self = this;
        $self.setState({
            touch_values : { start : start_touch }
        });
        setTimeout(function(){
            $self.setState({
                touch_values : { start : 0 }
            });
        }, 500);
    }
    moveStart(e) {
        let $self = this;
        let start_touch = e.targetTouches[0].clientX;
        $self._setStart(start_touch);
    }
    moveEnd(touchEndEvent) {
        const start_touch   = this.state.touch_values.start;
        const end_touch     = touchEndEvent.changedTouches[0].clientX;
        const difference    = Math.abs(start_touch - end_touch);
        if(start_touch !== 0){
            if (difference > 300) {
                if (start_touch > end_touch){
                    if(this.state.max_slide > this.state.active_slide.index){
                        const slide_number = this.state.active_slide.index + 1;
                        const active_slide = this.state.slides[slide_number];
                        this.activeSlide(active_slide)
                    }           
                }else{
                    if (this.state.min_slide <= this.state.active_slide.index) {
                        const slide_number = this.state.active_slide.index - 1;
                        const active_slide = this.state.slides[slide_number];
                        this.activeSlide(active_slide)
                    }
                }
            }
        }
    }
    componentWillReceiveProps(props) {
        let response    = props.app.state.occupancy_response_request;
        this.setState({
            response_request : response,
        })
    }

    render() {
        return (
            <div className="layout">
                <div className={"loading-panel " + this.state.request_status + " " + (this.props.app.state.panel !== "occupancy" ? "hide" : "")}>
                    <div className="bkg-stars">
                        <span className="figure-1"></span>
                    </div>
                </div>
                <div style={positionLeft(0, this.state.active_slide.index)} className={"slide " + isActiveSlide(this.state.active_slide.key, "general", "main-slide")}>
                    <General
                        request_status={this.state.request_status}
                        response_request={this.state.response_request}
                        panel={this.props.app.state.panel}
                        current_slide={this.state.active_slide.key}
                        current_year={this.props.app.state.current_year}
                        past_year={this.props.app.state.past_year}
                        view_results={this.props.app.state.view_results}
                        ref={(General) => { this._General = General; }}
                    />
                </div>
                <div style={positionLeft(0, this.state.active_slide.index)} className={"slide " + isActiveSlide(this.state.active_slide.key, "availability", "main-slide")}>
                    <Availability
                        request_status={this.state.request_status}
                        response_request={this.state.response_request}
                        panel={this.props.app.state.panel}
                        current_slide={this.state.active_slide.key}
                        current_year={this.props.app.state.current_year}
                        currentFilters={this.props.app.currentFilters}
                        past_year={this.props.app.state.past_year}
                        view_results={this.props.app.state.view_results}
                        hotels={this.props.app.state.hotels}
                        active_hotels={this.props.app.state.current_filter_properties}
                        ref={(Availability) => { this._Availability = Availability; }}
                    />
                </div>
                <div className={"slide-keys " + (this.props.app.state.panel !== "occupancy" ? "hide" : "")}>
                    <div className="tabs">
                        <div className={this.state.tab_submodule} onClick={this.activeSubmoduleTab.bind(this)}>SUBMODULOS</div>
                        <div className={this.state.tab_filters} onClick={this.activeFiltersTab.bind(this)}>FILTROS</div>
                    </div>
                    <div className={"content-filters " + this.state.tab_filters}>
                    </div>
                    <div className={"content-submodules " + this.state.tab_submodule}>
                        <div className={isActiveSlide(this.state.active_slide.key, "general")} onClick={this.activeSlide.bind(this, {key : "general", index : 0})}>
                            <span className="title">GENERAL</span>
                            <span className="section"></span>
                        </div>
                        <div className={isActiveSlide(this.state.active_slide.key, "availability")} onClick={this.activeSlide.bind(this, {key : "availability", index : 1})}>
                            <span className="title">VIABILIDAD</span>
                            <span className="section"></span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Layout



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/occupancy/Layout.js